import axios, { AxiosInstance } from "axios";
import { setLocalStorageToken } from "../Utils/utils";

type versionType = "v1" | "v2" | "v3 " | "v4";

const baseURL = process.env?.REACT_APP_BASE_URL;
const getLocalStorage = JSON.parse(localStorage.getItem("token")!);
const REFRESH_TOKEN = getLocalStorage?.refresh_token;

const baseApi: AxiosInstance = axios.create({
  baseURL,
});

export const fetchApi: AxiosInstance = axios.create({
  baseURL,
});

export default baseApi;

// A flag to prevent multiple refresh calls
let isRefreshing = false;
let failedQueue: {
  resolve: (value?: any) => void;
  reject: (error: any) => void;
}[] = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Add interceptor to fetchApi to handle token refresh
fetchApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return fetchApi(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      isRefreshing = true;

      try {
        // Call your refresh token API endpoint here
        // For example:
        const response = await baseApi.post(
          `/api/${version1}/auth/refresh?refresh_token=${REFRESH_TOKEN}`,
          {}
        );
        console.log("===>", response);

        localStorage.setItem("token", JSON.stringify(response.data));
        setLocalStorageToken(JSON.stringify(response.data));

        const newAccessToken = response.data.access_token;

        // Update default authorization header with new token
        fetchApi.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${newAccessToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

        processQueue(null, newAccessToken);

        return fetchApi(originalRequest);
      } catch (err) {
        processQueue(err, null);
        // Optionally: handle logout or redirect on refresh token failure
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);
export const version1: versionType = "v1";
